var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{attrs:{"color":"#fff","value":_vm.loading,"absolute":true}},[(_vm.loading)?_c('Cog'):_vm._e()],1),_c('div',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }